import styled from 'styled-components';

export const Title = styled.h3`
  margin-bottom: 2rem;
  margin-top: 3rem;
  font-size: var(--font-size-title-sm);
  text-align: center;
  font-weight: 700;
  font-family: var(--font-tertiary);
  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: var(--font-size-title-md);
    text-align: left;
    line-height: 1.25;
    margin-right: 4rem;
  }
`;

export const BannerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--border-light-transparent);
  border-bottom: 1px solid var(--border-light-transparent);
  padding: 3.6rem 3rem 5.7rem;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: var(--color-text-light);
  @media (${({ theme }) => theme.respondTo.tablet}) {
    flex-direction: row;
    justify-content: space-between;
    padding: 3rem;
  }
`;

export const ColumnWrapper = styled.div`
  text-align: center;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    text-align: left;
  }
`;

export const Column = styled.div`
  font-size: var(--font-size-sm);
  flex: 0 0 50%;
  margin-bottom: 3.5rem;
  line-height: 1.75;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    margin-right: 4rem;
    margin-bottom: 0;
  }
`;

export const ImageContainer = styled.div`
  flex-shrink: 0;
  border-radius: 50px 0px;
  overflow: hidden;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    margin-right: 7.5rem;
  }
`;

export const ButtonWrapper = styled.div`
  flex-shrink: 0;
`;
